// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wt_a bik_b bik_we"};